<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O57WT6/tc-custom/9781504010061.jpg?1728327144330" alt="This image is the cover for the book Scandal, The Harwood Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scandal, The Harwood Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>When a man searching for his brother uncovers a secret that could destroy a powerful nobleman’s life, he is offered the man’s daughter in exchange for his silence—but could their marriage of convenience turn into a love more powerful than the secrets keeping them apart? </b><br/><br/> When Gideon Harwood returns to his home in Regency-era England after a trip to India makes him an immensely rich man, he is driven by two unrelenting quests: to raise his station in life for the sake of his young sisters and to find his missing brother. What he uncovers is a damning secret about Lord Stanwell, one of London’s most powerful noblemen. Desperate to avoid a ruinous scandal, Lord Stanwell buys Gideon’s silence by offering the one thing that will guarantee Gideon’s entry into the beau monde’s inner sanctum: his daughter, Julia.<br/>  <br/> Now in her third insufferable social season, beautiful Lady Julia Barham has yet to meet a man deserving of her devotion. Rumors swirl about the towering, immensely wealthy Gideon Harwood, but he is a commoner, beneath her consideration—and yet, as she learns, he is to be her husband.  <br/>  <br/> Julia comes to find that Gideon awakens passion in her that she didn’t know she had. But dangerous secrets lie between them. Can they overcome the sins of the past and surrender to a once-in-a-lifetime love?<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Cullman
      </h2>
      
      <p class="authorDescription body article">Heather Cullman has a degree in fashion and design and has always wanted to be a writer. She lives with her husband, a lawyer, in Long Beach, California. She is the author of eight historical romances.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fc90b57a